import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { BookingCta } from "@/components/site/BookingCta";
import { StickyBookBar } from "@/components/site/StickyBookBar";

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [location]);

  return (
    <div className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <BookingCta />
        <Services />
        <Manifesto />
        <BookingCta
          title="Uma conversa pode mudar muita coisa."
        />
        <Testimonials />
        <Contact />
      </main>
      {/* spacer so the fixed mobile booking bar never covers the footer */}
      <div className="h-20 md:hidden" aria-hidden="true" />
      <Footer />
      <StickyBookBar />
    </div>
  );
}
